import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {icons} from 'src/app/ui/icons';
import {ConsultationService} from 'src/app/modules/services/consultation/consultation.service';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {ToastService} from 'src/app/modules/toast/toast.service';

type Column = keyof any;

@Component({
    selector: 'app-details-listchahier-shop',
    templateUrl: './details-listchahier-shop.component.html',
    styleUrls: ['./details-listchahier-shop.component.css']
})
export class DetailsListchahierShopComponent implements OnInit {

    @ViewChild(MatTable, {static: true}) table: MatTable<any>;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    data: any = [];
    @Input() id;
    isLoading: boolean;
    displayedColumns: Column[] = ['seqNo', 'cdNmFr', 'fileNm', 'bidAttNodeRef'];
    displayedColumnsFr: Column[] = ['seqNo', 'cdNmFr', 'fileNm', 'bidAttNodeRef'];
    displayedColumnsAr: Column[] = ['seqNo', 'cdNmAr', 'fileNm', 'bidAttNodeRef'];
    displayedColumnsEn: Column[] = ['seqNo', 'cdNm', 'fileNm', 'bidAttNodeRef'];
    dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    labels: Partial<Record<Column, string>> = {
        seqNo: 'Numéro',
        cdNmFr: 'Type du document',
        fileNm: 'Nom du document'
    };
    @Input() ondelete: boolean;

    icons = icons;
    langue: string;


    constructor(
        private achservice: ConsultationService,
        private appTranslateService: AppTranslateService,
        private toastService: ToastService,
    ) {
    }

    get readColumns() {
        if (this.langue === 'ar') {
            this.displayedColumns = this.displayedColumnsAr;
        } else if (this.langue === 'fr') {
            this.displayedColumns = this.displayedColumnsFr;
        } else {
            this.displayedColumns = this.displayedColumnsEn;
        }
        return this.displayedColumns;
    }

    ngOnInit(): void {

        this.langue = this.appTranslateService.getDefaultLang();


        this.loadDataSource();
    }

    loadDataSource() {

        this.isLoading = true;
        this.achservice
            .getCahierList(this.id)
            .subscribe({
                next: (cahier) => {

                    this.data = cahier;

                    this.dataSource.data = this.data;
                    // console.log('this.data :: ',this.data)

                },
                error: () => {
                    this.isLoading = false;
                    this.toastService.error('server_error');
                },
                complete: () => {
                    this.isLoading = false;
                },
            });

    }


    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;

    }
}
 
